// extracted by mini-css-extract-plugin
export const card = "j_K";
export const btn = "j_p";
export const txt404 = "j_L";
export const txtTitle = "j_d";
export const txtDes = "j_M";